import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLocationSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLocationSparkle"><Path d="M8 6H12V8H8V16H5.5C4.67157 16 4 16.6716 4 17.5C4 18.3284 4.67157 19 5.5 19H19V13H21V21H5.5C3.567 21 2 19.433 2 17.5V6.5C2 4.567 3.567 3 5.5 3H8V6Z" fill="currentColor"/><Path d="M18.4004 3L19.4004 5.59961L22 6.59961V7.40039L19.4004 8.40039L18.4004 11H17.5996L16.5996 8.40039L14 7.40039V6.59961L16.5996 5.59961L17.5996 3H18.4004Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLocationSparkle;
